export default __webpack_public_path__ + "locales/uk-UA/ChangePhoneDialog.json?hash=6f0643f9e775a8db5aecb2bc1f6ea4d4";